import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString } from '../../../../../utils/stringify-utils';
import { PinNodeCreateProps } from '../models/pin-node-create-props';
import { PinNode } from '../models/pin-node.model';
import { calculatePinScale } from '../utils/calculate-pin-scale';

export const createPinNode = (diagram: go.Diagram, { categoryName, location }: PinNodeCreateProps) => {
  const key = uuid.v4();

  diagram.commit(() =>
    diagram.model.addNodeData(new PinNode(key, categoryName, getPointString(location.x, location.y))),
  );
  const node = diagram.findNodeForKey(key);
  if (node) {
    assignProperScale(node);
    diagram.select(node);
  }

  return node;
};

const assignProperScale = (node: go.Node) => {
  if (node.diagram) {
    node.scale = calculatePinScale(node.diagram);
  }
};
